import styled from 'styled-components';

import { PickActionType } from '@/core/components/PickActionType';
import { BackgroundElement } from '@/core/interfaces/common';

import mediaQueries from '@/utils/mediaQueries';
import { colors } from '@/utils/constants';

import { WhyTakeActionWrapper } from '@/themes/globalStyles';

const { small } = mediaQueries;

export const StyledWhyTakeActionWrapper = styled(WhyTakeActionWrapper)`
  max-width: unset;
`;

export const StyledPickActionType = styled(PickActionType)`
  margin: 0;
`;

export const PickActionTypeWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const ResetFormButton = styled.button`
  display: block;
  border: 0;
  background-color: inherit;
  cursor: pointer;
`;

export const ResetForm = styled.span<BackgroundElement>`
  color: ${props => (props.textcolor)};
  font-weight: 700;
`;

export const FormWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 52px;
  margin: -200px 16px 40px;
  border-radius: 4px;
  padding: 24px;
  background-color: ${colors.white};

  @media ${small} {
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const LogoWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;

  @media ${small} {
    position: static;
    margin-bottom: 40px;
  }
`;
